const pageClinicalStaffSlider = {
  initializeSlider: () => {
    $(".unit__team-slider:not(.slick-initialized)").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 780,
          settings: {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
          },
        },
      ],
    });
    
    $(".themeAboutUs__priorities-cards").slick({
      infinite: true,
      slidesToShow: 5,
      arrows: false,
      dots: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 780,
          settings: {
            infinite: false,
            slidesToShow: 2,
            arrows: false,
            dots: false,
          },
        },
      ],
    });
  },
  openCurriculim: () => {
    $(".open-curriculum").on("click", function (e) {
      e.preventDefault();
      const element = $(this);
      const parentContainer = element
        .parents(".unit__team-slider-card")
        .find(".unit__team-slider-card-curriculum-curriculum")
        .html();
      $(".memberCurriculum").html(parentContainer);

      const curriculumContainer =
        ".unit__team-slider-card-curriculum-curriculum";
      $(curriculumContainer).fadeOut();

      $(
        ".memberCurriculum .unit__team-slider-card-curriculum-curriculum, .memberCurriculum"
      )
        .fadeIn()
        .css({ display: "flex" });
    });
  },
  openVideo: () => {
    $(document).on("click", ".open-video", function (e) {
      e.preventDefault();
      const element = $(this);
      const parentContainer = element
        .parents(".unit__team-slider-card")
        .find(".unit__team-slider-card-curriculum-video")
        .html();
      $(".memberVideo").html(parentContainer);

      const curriculumContainer = ".unit__team-slider-card-curriculum-video";
      $(curriculumContainer).fadeOut();

      $(".memberVideo .unit__team-slider-card-curriculum-video, .memberVideo")
        .fadeIn()
        .css({ display: "flex" });
    });
  },
  closeCurriculum: () => {
    $(document).on("click", ".close-curriculum", function (e) {
      const curriculumContainer = ".memberVideo, .memberCurriculum";
      $(curriculumContainer).fadeOut();
    });
  },
  init: () => {
    pageClinicalStaffSlider.initializeSlider();
    pageClinicalStaffSlider.openCurriculim();
    pageClinicalStaffSlider.closeCurriculum();
    pageClinicalStaffSlider.openVideo();
  },
};

export default pageClinicalStaffSlider;
